import { BodyText, Callout, Separator, Skeleton } from "@/components/ui";
import { useParams } from "@tanstack/react-router";
import { Fragment } from "react/jsx-runtime";
import { SectionContent } from "../../components/SectionContent";
import { SectionHeader } from "../../components/SectionHeader";
import { useGetMiscellaneousNotes } from "../network";
import { MiscellaneousNoteItem } from "./MiscellaneousNoteItem";

export const HealthMaintenanceMiscellaneous = () => {
  const { patientId } = useParams({ from: "/patient/$patientId" });
  const {
    data: miscNotes,
    isLoading,
    isError,
    refetch,
  } = useGetMiscellaneousNotes(patientId);

  const isDataLoadError = !isLoading && (isError || !miscNotes);
  const isDataLoadSuccess =
    !isLoading && !isDataLoadError && miscNotes && miscNotes.notes.length > 0;
  const noNotes =
    !isLoading && !isDataLoadError && miscNotes?.notes.length === 0;

  return (
    <div className="w-full h-full flex flex-col mt-2">
      <SectionHeader title="Miscellaneous" />
      <SectionContent>
        {isLoading && (
          <>
            <div className="flex flex-row gap-2">
              <Skeleton className="h-10 m-2 w-full" />
            </div>
            <Separator />
          </>
        )}
        {isError && (
          <div className="flex flex-col gap-2 py-2 w-full">
            <Callout
              className="w-full cursor-pointer"
              variant="danger"
              title="Unable to load notes!"
              description="Please click here to try again."
              onClick={() => refetch()}
            />
            <Separator />
          </div>
        )}
        {noNotes && (
          <BodyText size="sm" textColor="tertiary" className="mt-2">
            No miscellaneous notes recorded
          </BodyText>
        )}
        {isDataLoadSuccess &&
          miscNotes.notes.map((note) => (
            <Fragment key={note.id}>
              <MiscellaneousNoteItem key={note.id} {...note} />
              <Separator className="w-full" />
            </Fragment>
          ))}
      </SectionContent>
    </div>
  );
};
